import Icon from '@mdi/react';
import React from 'react';
import styled from '@emotion/styled/macro';
import { Variables } from '../base';
import { IClaimProgressEvent } from './claim-progress-derivation';
import { OVERLAY_VIEW, TONE_COLORS, Tone, VISUAL_STATE_VIEW } from './claim-progress-visuals';

const Pill = styled.span<{ $tone: Tone; $large: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: ${({ $large }) => ($large ? 5 : 4)}px;
    padding: ${({ $large }) => ($large ? '5px 10px' : '3px 7px')};
    border-radius: 999px;
    white-space: nowrap;
    background: ${({ $tone }) => TONE_COLORS[$tone].background};
    color: ${({ $tone }) => TONE_COLORS[$tone].foreground};
    font-family: ${Variables.Fonts.calibre};
    font-size: ${({ $large }) => ($large ? 10 : 9)}px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    svg {
        fill: currentColor;
    }
`;

interface IClaimStatePillsProps {
    event: Pick<IClaimProgressEvent, 'visualState' | 'overlays'>;
    large?: boolean;
}

/**
 * The outcome pill plus any PAUSED / REWORK overlays. A paused row whose owner the tuple does not
 * name shows only "Paused" — an extra "Unclassified" pill beside it would say nothing true.
 */
export const ClaimStatePills: React.FC<IClaimStatePillsProps> = ({ event, large = false }) => {
    const view = VISUAL_STATE_VIEW[event.visualState];
    const paused = event.overlays.includes('PAUSED');
    const hideBase = paused && event.visualState === 'UNCLASSIFIED';
    const iconSize = large ? 0.65 : 0.55;

    return (
        <>
            {!hideBase && (
                <Pill $tone={view.tone} $large={large}>
                    <Icon path={view.icon} size={iconSize} />
                    {view.label}
                </Pill>
            )}
            {event.overlays.map(overlay => (
                <Pill key={overlay} $tone="amber" $large={large}>
                    <Icon path={OVERLAY_VIEW[overlay].icon} size={iconSize} />
                    {OVERLAY_VIEW[overlay].label}
                </Pill>
            ))}
        </>
    );
};
